(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-video-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.lpvrReady) return;
      root.dataset.lpvrReady = '1';

      var rail = root.querySelector('[data-lpvr-rail]');
      var box = document.querySelector('[data-lpvr-box]');
      var frame = box && box.querySelector('[data-lpvr-frame]');
      var who = box && box.querySelector('[data-lpvr-boxwho]');
      var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-lpvr-src]'));
      var current = -1;
      var lastFocus = null;

      function close() {
        if (!box) return;
        box.hidden = true;
        frame.innerHTML = '';
        document.documentElement.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      }

      function play(index) {
        if (!box || !triggers[index]) return;
        current = index;
        var btn = triggers[index];
        var src = btn.getAttribute('data-lpvr-src');
        if (!src) return;
        frame.innerHTML = '';
        var v = document.createElement('video');
        v.src = src;
        v.controls = true;
        v.autoplay = true;
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        v.preload = 'auto';
        frame.appendChild(v);
        if (who) who.textContent = btn.getAttribute('data-lpvr-who') || '';
        box.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        v.play().catch(function () {});
      }

      triggers.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          lastFocus = btn;
          play(i);
        });
      });

      if (box) {
        box.addEventListener('click', function (e) {
          if (e.target === box || e.target.hasAttribute('data-lpvr-close')) close();
        });
        document.addEventListener('keydown', function (e) {
          if (box.hidden) return;
          if (e.key === 'Escape') close();
          if (e.key === 'ArrowRight' && current < triggers.length - 1) play(current + 1);
          if (e.key === 'ArrowLeft' && current > 0) play(current - 1);
        });
      }

      root.querySelectorAll('[data-lpvr-scroll]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = rail.querySelector('.lpvr__card');
          if (!card) return;
          var step = card.getBoundingClientRect().width + 16;
          rail.scrollBy({ left: step * parseInt(btn.getAttribute('data-lpvr-scroll'), 10), behavior: 'smooth' });
        });
      });

      function arrows() {
        var prev = root.querySelector('.lpvr__arrow--prev');
        var next = root.querySelector('.lpvr__arrow--next');
        if (!prev || !next) return;
        prev.hidden = rail.scrollLeft < 8;
        next.hidden = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8;
      }
      rail.addEventListener('scroll', arrows, { passive: true });
      arrows();
    }

    function boot() {
      document.querySelectorAll('[data-lpvr]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
